export default __webpack_public_path__ + "static/2-2f7e1198e0e065854e397d43be528cfb.webp";